import { getPaymentMethods, } from '../types'

const initState = {
  data: null,
  error: null,
  loading: false,
}

export default function getPaymentMethodsReducer (state = initState, action) {
  switch (action.type) {
    
    case getPaymentMethods.GET_PAYMENT_METHODS_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
        data: null
      }
    
    case getPaymentMethods.GET_PAYMENT_METHODS_PENDING:
      return {
        ...state,
        loading: true,
      }
    
    case getPaymentMethods.GET_PAYMENT_METHODS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: null,
      }

    default:
      return state
  }
}
